import { render, staticRenderFns } from "./qualificationInformation.vue?vue&type=template&id=580f0ee9&scoped=true&"
import script from "./qualificationInformation.vue?vue&type=script&lang=js&"
export * from "./qualificationInformation.vue?vue&type=script&lang=js&"
import style0 from "./qualificationInformation.vue?vue&type=style&index=0&id=580f0ee9&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "580f0ee9",
  null
  
)

export default component.exports